import React from 'react';
import styles from './HealthCard.module.scss';
import { getProjectHealthStatus } from '../reportMockData';

interface HealthCardProps {
  title: string;
  score: number;
  statusLabel: string;
  scoreLabel: string;
}

const HealthCard: React.FC<HealthCardProps> = ({ title, score, statusLabel, scoreLabel }) => {
  const { color } = getProjectHealthStatus(score);
  const pct = Math.max(0, Math.min(100, score));

  return (
    <div className={styles.card}>
      <div className={styles.head}>
        <span className={styles.title}>{title}</span>
        <span className={styles.pill} style={{ color, background: `${color}1a` }}>
          {statusLabel}
        </span>
      </div>
      <div className={styles.body}>
        <span className={styles.score} style={{ color }}>
          {score}
        </span>
        <div className={styles.meter}>
          <div className={styles.track}>
            <div className={styles.fill} style={{ width: `${pct}%`, background: color }} />
          </div>
          <span className={styles.scoreLabel}>{scoreLabel}</span>
        </div>
      </div>
    </div>
  );
};

export default HealthCard;
